module.exports = __webpack_public_path__ + "img/rongYu2.0fc4bce5.png";